import {
    handleActions,
    Action,
} from 'redux-actions';

import {QC_REPORTS_STATUSES_SET, QCReportsStatusesPayload} from './QCReportsStatusesActions';
import {QCReportsStatusesState, QCReportStatusEnum} from '../QCReportsStatusesTypes';

const mapToSelect = (e: QCReportStatusEnum) => ({
    value: e,
    label: e,
});

export const setQcReportsStatuses = (state: QCReportsStatusesState, action: Action<QCReportsStatusesPayload>): QCReportsStatusesState => {
    const {payload} = action;
    
    if (payload.length)
        return {
            statuses: payload.map(mapToSelect),
            isLoading: false,
        };
    
    return state;
};

export const initialState = {
    statuses: [],
    isLoading: true,
};

const handlers = {
    [QC_REPORTS_STATUSES_SET]: setQcReportsStatuses,
};

export default handleActions(handlers, initialState);
